import { tickerUpdates } from "@/mocks/home";

export default function UpdateTicker() {
  return (
    <div className="w-full border-b border-background-200 bg-foreground-950">
      <div className="flex h-10 w-full items-center gap-4 px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-flashlight-line text-[11px]"></i>
          </span>
          实时更新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-10">
            {[...tickerUpdates, ...tickerUpdates].map((text, index) => (
              <span
                key={`${text}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-background-200 md:text-[13px]"
              >
                <span className="h-1 w-1 rounded-full bg-primary-400"></span>
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}